export default __webpack_public_path__ + "static/media/1706.3c47a800.png";